import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const desempenhoRepository = RepositoryFactory.get('desempenho');

const state = {
  desempenho: {
    notaAgrupada: 0,
    notaAgrupadaResponsabilidade: 0,
    resultadosComportamentais: [],
    resultadosResponsabilidade: [],
    cds: 0,
  },
  graficosComportamentais: {
    bar: {
      autoavaliacao: { categorias: [], dados: [] },
      gestor: { categorias: [], dados: [] },
      subordinados: { categorias: [], dados: [] },
      pares: { categorias: [], dados: [] },
    },
    gauge: { dados: [] },
    loaded: false,
  },
  graficosCoeficiente: {
    bubble: { dados: [] },
    loaded: false,
  },
  tiposComplexidade: [
    {
      nome: 'Baixa',
      descricao: 'Complexidade Baixa',
      descricaoAcao: 'Acompanhamento simples de responsabilidade.',
      color: '#348ECA',
    },
    {
      nome: 'Média',
      descricao: 'Complexidade Média',
      descricaoAcao: 'Acompanhamento moderado de responsabilidade.',
      color: '#2D5269',
    },
    {
      nome: 'Alta',
      descricao: 'Complexidade Alta',
      descricaoAcao: 'Acompanhamento prioritário de responsabilidade.',
      color: '#00ABA4',
    },
  ],
  tiposDificuldade: [
    {
      nome: '1',
      descricao: 'Dificuldade 1',
      descricaoAcao: 'Atividade está organizada ou estruturada.',
      color: '#348ECA',
    },
    {
      nome: '2',
      descricao: 'Dificuldade 2',
      descricaoAcao: 'Atividade pouco organizada ou estruturada.',
      color: '#2D5269',
    },
    {
      nome: '3',
      descricao: 'Dificuldade 3',
      descricaoAcao: 'Atividade ainda sem organização ou estrutura definidas.',
      color: '#00ABA4',
    },
  ],
  tiposImpacto: [
    {
      nome: '1',
      descricao: 'Impacto 1',
      descricaoAcao: 'Fica limitado ao setor.',
      color: '#348ECA',
    },
    {
      nome: '2',
      descricao: 'Impacto 2',
      descricaoAcao: 'Afeta várias áreas, mas é administrável.',
      color: '#2D5269',
    },
    {
      nome: '3',
      descricao: 'Impacto 3',
      descricaoAcao: 'Ultrapassa os portões da instituição.',
      color: '#00ABA4',
    },
  ],
  tiposCategoriaCDS: [
    {
      id: 'NAO_ATENDE',
      nome: 'Não Atende',
      descricao: 'Não Atende',
      color: '#348ECA',
    },
    {
      id: 'EM_DESENVOLVIMENTO',
      nome: 'Em Desenvolvimento',
      descricao: 'Em Desenvolvimento',
      color: '#2D5269',
    },
    {
      id: 'ATENDE',
      nome: 'Atende',
      descricao: 'Atende',
      color: '#00ABA4',
    },
  ],
  loaded: false,
};

const actions = {
  load({ commit }, payload) {
    return new Promise((resolve) => {
      desempenhoRepository.get(payload.diagnostico.id).then((response) => {
        commit('SET_DESEMPENHO', response.data);
        commit('SET_LOADED', true);
        resolve();
      });
    });
  },
  setGraficos({ commit }, payload) {
    if (payload.perspectiva === 'COMPORTAMENTAL') {
      commit('SET_GRAFICOS_COMPORTAMENTAIS', payload.graficos);
    }
  },
  setGraficosCoeficiente({ commit }, payload) {
    commit('SET_GRAFICOS_COEFICIENTE', payload.graficos);
  },
  setLoadedStatus({ commit }, status) {
    commit('SET_LOADED', status);
  },
};

const getters = {
  graficosResponsabilidade(st) {
    if (!st.loaded) {
      return null;
    }

    const graficos = {
      bar: {
        autoavaliacao: { categorias: [], dados: [] },
        gestor: { categorias: [], dados: [] },
      },
      gauge: { dados: [] },
    };

    if (st.desempenho.foiDispensado) {
      return graficos;
    }

    const categorias = [];
    const notasMaximas = [];
    const notasAutoavaliacao = [];
    const notasGestor = [];

    st.desempenho.resultadosResponsabilidade.forEach((resultado) => {
      categorias.push(resultado.responsabilidade.titulo);
      notasMaximas.push(resultado.notaMaxima);

      notasAutoavaliacao.push(resultado.notaAutoavaliacao);
      notasGestor.push(resultado.notaGestor);
    });

    graficos.bar.autoavaliacao.categorias = [...categorias];
    graficos.bar.autoavaliacao.dados.push(
      { name: 'Resultado Máximo', data: notasMaximas, color: '#2D5269' },
      { name: 'Resultado das Avaliações', data: notasAutoavaliacao, color: '#348ECA' },
    );

    graficos.bar.gestor.categorias = [...categorias];
    graficos.bar.gestor.dados.push(
      { name: 'Resultado Máximo', data: notasMaximas, color: '#2D5269' },
      { name: 'Resultado das Avaliações', data: notasGestor, color: '#348ECA' },
    );

    graficos.gauge.dados.push(parseFloat((st.desempenho.notaAgrupadaResponsabilidade * 10)
      .toFixed(2)));
    graficos.loaded = true;

    return graficos;
  },
};

const mutations = {
  SET_DESEMPENHO: (st, desempenho) => {
    st.desempenho = desempenho;
  },
  SET_GRAFICOS_COMPORTAMENTAIS: (st, graficos) => {
    st.graficosComportamentais = graficos;
  },
  SET_GRAFICOS_COEFICIENTE: (st, graficos) => {
    st.graficosCoeficiente = graficos;
  },
  SET_LOADED: (st, status) => {
    st.loaded = status;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
